/**
 * Blog Post Registry
 *
 * To add a new blog post:
 * 1. Create a folder: public/blog/posts/<slug>/
 * 2. Add index.md (your article) inside that folder
 * 3. Add cover.jpg (optional cover image) inside that folder
 * 4. Add an entry below with title, slug, category, date, excerpt, tags, author
 *
 * contentPath and coverImage are auto-derived from slug — no need to add them manually.
 * The `slug` must exactly match the folder name under public/blog/posts/.
 * New categories appear as filter tabs automatically.
 */

const rawPosts = [
  {
    title: "Creating a Wait Utility in Selenium (Java)",
    slug: "selenium-java",
    date: "2026-10-30",
    excerpt:
      "Instead of writing WebDriverWait logic in every test, created a small utility class to handle all waits in one place for clean and easy-to-read tests.",
    coverImage: "/blog/posts/selenium-java/cover.jpg",
    tags: ["Selenium", "Java", "AutomationTesting", "QA", "SDET"],
    category: "Selenium",
    author: "Gulshan Kumar",
    readingTime: "3 min read",
  },
];

// Sort by date (newest first) — non-mutating
const blogPosts = [...rawPosts]
  .sort((a, b) => new Date(b.date) - new Date(a.date))
  .map((post) => ({
    ...post,
    // Derive content path from slug — always public/blog/posts/<slug>/index.md
    contentPath: `/blog/posts/${post.slug}/index.md`,
  }));

/**
 * Get all unique categories (used to render filter pills)
 */
export const getCategories = () => {
  const categories = [...new Set(blogPosts.map((post) => post.category))];
  return ["All", ...categories.sort()];
};

/**
 * Get all unique tags
 */
export const getAllTags = () => {
  const tags = [...new Set(blogPosts.flatMap((post) => post.tags))];
  return tags.sort();
};

/**
 * Get blog posts, optionally filtered by category
 */
export const getBlogPosts = (category = "All") => {
  if (category === "All") return blogPosts;
  return blogPosts.filter((post) => post.category === category);
};

/**
 * Get a single blog post by slug
 */
export const getBlogPostBySlug = (slug) => {
  return blogPosts.find((post) => post.slug === slug);
};

export default blogPosts;
